import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=2d7ff3a6&"
import script from "./NotificationComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=2d7ff3a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports